import { render, staticRenderFns } from "./sub-icon-card.vue?vue&type=template&id=4d56f0b1&scoped=true&"
import script from "./sub-icon-card.vue?vue&type=script&lang=js&"
export * from "./sub-icon-card.vue?vue&type=script&lang=js&"
import style0 from "./sub-icon-card.vue?vue&type=style&index=0&id=4d56f0b1&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d56f0b1",
  null
  
)

export default component.exports